import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'info-thin-icon',
  templateUrl: './info-thin-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class InfoThinIconComponent {}
